<template>
  <NavBar />
  <div class="container-fluid page-body-wrapper">
    <MenuBar />
    <div class="main-panel">
      <div class="content-wrapper">
        <div class="page-header">
          <h3 class="page-title">
            <span class="page-title-icon bg-gradient-primary text-white me-2">
              <i class="mdi mdi-format-list-bulleted"></i>
            </span>
            All Released Products
          </h3>
          <a
            class="btn btn-block btn-lg btn-gradient-primary"
            @click="btnAddNewClicked"
            v-if="
              auth_store.logged_in_user != undefined &&
              auth_store.logged_in_user.user != null &&
              auth_store.logged_in_user.user.usr_role != null &&
              auth_store.logged_in_user.user.usr_role.url_role_code != 'VWR' &&
              auth_store.logged_in_user.user.usr_role.url_role_code != 'RST'
            "
            >+ Add New Product</a
          >
        </div>
        <ManageProductRelease
          v-if="blnShowManagePRSec"
          v-on:posted-data="getPostedData"
          v-on:is_cance_clicked="getEventStatus"
          :objProductRelease="objSelectedPrdRelease"
          :addNewRelease="isNewRelease"
        >
        </ManageProductRelease>

        <div class="row">
          <div class="col-12 grid-margin">
            <div class="card">
              <div class="card-body">
                <RelasedProductList
                  :releasedProductList="lstProductReleases"
                  v-on:selected-data="getSelectedData"
                  v-on:prd-for-new_release="getDataForNewRelease"
                ></RelasedProductList>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { ref, onMounted } from "vue";
import ManageProductRelease from "@/components/shared/product-release/manage-product-release.vue";
import MenuBar from "@/components/shared/common/menu-bar.vue";
import NavBar from "@/components/shared/common/nav-bar.vue";
import RelasedProductList from "@/components/shared/product-release/released-product-list.vue";
import axios from "axios";
import { useAuthStore } from "@/store/auth_store";

import { useLoading } from "vue-loading-overlay";

const auth_store = useAuthStore();
// import CryptoJS from "crypto-js";

const blnShowManagePRSec = ref(false);
const lstProductReleases = ref([]);
const objSelectedPrdRelease = ref({});
const isNewRelease = ref(false);
const user = ref(null);
const $loading = useLoading();
// const secretKey = "ktqz2F4Bu6wOZGQn";

const btnAddNewClicked = () => {
  objSelectedPrdRelease.value = {
    prd_id: null,
    prd_name: "",
    prd_status: 1,
    prd_latest_firmware: "",
    prd_latest_version: "",
    prd_created_on: new Date(), //, 'yyyy-MM-dd  hh:mm:ss'),
    prd_created_by: user.value.user.usr_id, //loggeed In user Id
    prd_modified_on: null,
    prd_modified_by: null,
    prd_product_line: "-1",
  };
  blnShowManagePRSec.value = true;
  isNewRelease.value = false;
};

onMounted(() => {
  fetchProdctList();
  user.value = auth_store.logged_in_user;
});

function fetchProdctList() {
  const loader = $loading.show({});
  axios
    .post("/fetch_products")
    .then((res) => {
      if (res.data != null && res.data.length > 0) {
        loader.hide();

        lstProductReleases.value = res.data;
        
      }
    })
    .catch(() => {
      loader.hide();
    });
}

const getPostedData = (obj) => {
  
  fetchProdctList();
  blnShowManagePRSec.value = false;
};

const getEventStatus = (is_canceled) => {
  if (is_canceled == true) {
    blnShowManagePRSec.value = false;
    fetchProdctList();
  }
};

const getSelectedData = (objselectedItem) => {
  if (objselectedItem != null) {
    objSelectedPrdRelease.value = objselectedItem;
    objSelectedPrdRelease.value.prd_created_by = user.value.user.usr_id;
    blnShowManagePRSec.value = true;
  }
};

const getDataForNewRelease = (objselectedItem) => {
  if (objselectedItem != null) {
    objSelectedPrdRelease.value = objselectedItem;
    objSelectedPrdRelease.value.prd_created_by = user.value.user.usr_id;
    blnShowManagePRSec.value = true;
    isNewRelease.value = true;
  }
};
</script>
